import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CheckboxModule } from 'primeng/checkbox';
import { NormalSlickgridTableComponent } from './components/normal-slickgrid-table/normal-slickgrid-table.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NgChartsModule } from 'ng2-charts';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { CapacityChartComponent } from './components/charts/capacity-chart/capacity-chart.component';
import { DemandChartComponent } from './components/charts/demand-chart/demand-chart.component';
import { CapexRequiredChartComponent } from './components/charts/capex-required-chart/capex-required-chart.component';
import { RevenueChartComponent } from './components/charts/revenue-chart/revenue-chart.component';
import { CapacityWaterfallChartComponent } from './components/charts/capacity-waterfall-chart/capacity-waterfall-chart.component';
import { GlobalFilterComponent } from './components/global-filter/global-filter.component';
import { ArraySumPipe } from './pipes/array-sum.pipe';
import { NumberFormatterPipe } from './pipes/number-formatter.pipe';
import { LineFteChartComponent } from './components/charts/line-fte-chart/line-fte-chart.component';
import { MatInputModule } from '@angular/material/input';
import { YearPickerComponent } from './components/year-picker/year-picker.component';
import { ManufecturingNetworkChartComponent } from './components/charts/manufecturing-network-chart/manufecturing-network-chart.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DeleteAlertComponent } from './components/alerts/delete-alert/delete-alert.component';
import { SelectAllCheckboxComponent } from './components/select-all-checkbox/select-all-checkbox.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InventoryChartComponent } from './components/charts/inventory-chart/inventory-chart.component';
import { WarehouseCasesChartComponent } from './components/charts/warehouse-cases-chart/warehouse-cases-chart.component';
import { WarehouseSpaceChartComponent } from './components/charts/warehouse-space-chart/warehouse-space-chart.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { OtherCapexChartComponent } from './components/charts/other-capex-chart/other-capex-chart.component';
import { TooltipModule } from 'primeng/tooltip';
import { ScrollableChartComponent } from './components/charts/scrollable-chart/scrollable-chart.component';
import { PercentPillComponent } from './components/percent-pill/percent-pill.component';
import { CustomToggleBtnComponent } from './components/custom-toggle-btn/custom-toggle-btn.component';
import { InitMapComponent } from './components/init-map/init-map.component';
import { PlantFilterComponent } from './components/plant-filter/plant-filter.component';
import { DropdownModule } from 'primeng/dropdown';
import { MatSliderModule } from '@angular/material/slider';
import { RangeFilterComponent } from './components/range-filter/range-filter.component';
import { TabViewModule } from 'primeng/tabview';
import { ErrorBarPillComponent } from './components/error-bar-pill/error-bar-pill.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MdlzIconComponent } from './components/mdlz-icon/mdlz-icon.component';
import { LoaderComponent } from './components/loader/loader.component';
import { DialogModule } from 'primeng/dialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { InputNumberModule } from 'primeng/inputnumber';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ResponsePopupComponent } from './components/response-popup/response-popup.component';
import { QuarterYearPickerComponent } from './components/quarter-year-picker/quarter-year-picker.component';
import { MdmNavToggleBtnRoundedComponent } from './components/mdm-nav-toggle-btn-rounded/mdm-nav-toggle-btn-rounded.component';
import { ExpandableTableComponent } from './components/expandable-table/expandable-table.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TreeSelectModule } from 'primeng/treeselect';
import { FormatDecimalNumberPipe } from './pipes/format-decimal-number.pipe';
import { ScopeFormatterPipe } from './pipes/scope-formatter.pipe';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { InterventionsTableComponent } from './components/interventions-table/interventions-table.component';
import { PropertyFormatterPipe } from './pipes/property-formatter.pipe';
import { CustomLoaderComponent } from './components/custom-loader-component';
import { UtcToLocalPipe } from './pipes/utc-to-local.pipe';
import { GlobalFilterDialogComponent } from './components/global-filter-dialog/global-filter-dialog.component';

@NgModule({
  declarations: [
    PageNotFoundComponent,
    NormalSlickgridTableComponent,
    CapacityChartComponent,
    DemandChartComponent,
    CapexRequiredChartComponent,
    RevenueChartComponent,
    CapacityWaterfallChartComponent,
    GlobalFilterComponent,
    ArraySumPipe,
    NumberFormatterPipe,
    LineFteChartComponent,
    YearPickerComponent,
    ManufecturingNetworkChartComponent,
    DeleteAlertComponent,
    SelectAllCheckboxComponent,
    InventoryChartComponent,
    WarehouseCasesChartComponent,
    WarehouseSpaceChartComponent,
    OtherCapexChartComponent,
    ScrollableChartComponent,
    PercentPillComponent,
    CustomToggleBtnComponent,
    InitMapComponent,
    PlantFilterComponent,
    RangeFilterComponent,
    MdlzIconComponent,
    ErrorBarPillComponent,
    LoaderComponent,
    ProgressBarComponent,
    ResponsePopupComponent,
    QuarterYearPickerComponent,
    MdmNavToggleBtnRoundedComponent,
    ExpandableTableComponent,
    FormatDecimalNumberPipe,
    ScopeFormatterPipe,
    InterventionsTableComponent,
    PropertyFormatterPipe,
    UtcToLocalPipe,
    GlobalFilterDialogComponent,
  ],
  imports: [
    OverlayModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    CheckboxModule,
    DragDropModule,
    AngularSlickgridModule.forRoot(),
    NgxMatSelectSearchModule,
    TooltipModule,
    DropdownModule,
    MatSliderModule,
    MatStepperModule,
    MatIconModule,
    ClipboardModule,
    MatRadioModule,
    MatTooltipModule,
    ButtonModule,
    TableModule,
    RadioButtonModule,
    TreeSelectModule,
    MatTableModule,
    ConfirmDialogModule,
    CustomLoaderComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AngularSlickgridModule,
    MatExpansionModule,
    MatCheckboxModule,
    CheckboxModule,

    PageNotFoundComponent,
    NormalSlickgridTableComponent,
    MatButtonToggleModule,
    NgChartsModule,
    MatDialogModule,
    CapacityChartComponent,
    DemandChartComponent,
    CapexRequiredChartComponent,
    RevenueChartComponent,
    CapacityWaterfallChartComponent,
    GlobalFilterComponent,
    GlobalFilterDialogComponent,
    ArraySumPipe,
    NumberFormatterPipe,

    LineFteChartComponent,
    YearPickerComponent,
    ManufecturingNetworkChartComponent,
    OverlayPanelModule,
    TableModule,
    ConfirmDialogModule,
    DeleteAlertComponent,
    DragDropModule,
    InputTextModule,
    InputTextareaModule,
    InventoryChartComponent,
    WarehouseCasesChartComponent,
    WarehouseSpaceChartComponent,
    OtherCapexChartComponent,
    NgxMatSelectSearchModule,
    TooltipModule,
    ScrollableChartComponent,
    PercentPillComponent,
    CustomToggleBtnComponent,
    InitMapComponent,
    PlantFilterComponent,
    DropdownModule,
    MatSliderModule,
    ClipboardModule,
    InputNumberModule,
    TabViewModule,
    MatStepperModule,
    MatIconModule,
    MdlzIconComponent,
    ErrorBarPillComponent,
    LoaderComponent,
    DialogModule,
    ContextMenuModule,
    MatRadioModule,
    MatTooltipModule,
    ProgressBarComponent,
    QuarterYearPickerComponent,
    MdmNavToggleBtnRoundedComponent,
    ExpandableTableComponent,
    InterventionsTableComponent,
    RadioButtonModule,
    TreeSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    ScrollingModule,
    ScopeFormatterPipe,
    FormatDecimalNumberPipe,
    CustomLoaderComponent,
    UtcToLocalPipe,
  ],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useFactory: (overlay: Overlay) => ({
        scrollStrategy: overlay.scrollStrategies.noop(), // Example: Block scrolling
        hasBackdrop: true, // Other global configurations
        disableClose: false,
      }),
      deps: [Overlay],
    },
  ],
})
export class SharedModule {}
